import { EventState, ID, LineItemUpdateMechanism, LotChanges } from 'types';
import { ApiUrl, Call, ParseGeneralResponse } from '@api/ApiUtils';
import { prepareChanges } from '@api/events/utils';

interface SaveEventResponse {
  errors: string[];
  success: boolean;
}

interface Props {
  event: EventState;
  id: ID;
  lotChanges: Record<ID, LotChanges>;
  mechanism?: LineItemUpdateMechanism;
}

export const saveEvent = async ({ event, id, lotChanges, mechanism }: Props): Promise<SaveEventResponse> => {
  const url = ApiUrl(`/events/${id}`);

  const body: { changes: ReturnType<typeof prepareChanges>; mechanism?: LineItemUpdateMechanism } = {
    changes: prepareChanges(lotChanges, event)
  };
  if (mechanism) body.mechanism = mechanism;

  return Call(
    'put',
    url,
    body,
    ParseGeneralResponse,
    { responseDataKeys: {}, return: {} }
  );
};
